import { useLocale, usePluginHost } from '../plugin-host-context';

/** 플러그인 문구 조회 — 현재 로케일 → ko → 키 순으로 떨어진다 */
export function usePluginMessages(plugin: string): (key: string) => string {
  const host = usePluginHost();
  const locale = useLocale();
  return key => host.message(locale, `${plugin}.${key}`) ?? host.message('ko', `${plugin}.${key}`) ?? key;
}
